// app/javascript/dashboard/store/modules/availability.js

import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AvailabilityAPI from '../../api/availability';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getAvailabilityReasons(_state) {
    return _state.records;
  },
  getAvailabilityUIFlags: _state => _state.uiFlags,
};

const actions = {
  getAvailability: async function getAvailability({ commit }, accountId) {
    commit(types.SET_AVAILABILITY_UI_FLAG, { fetchingList: true });
    try {
      const response = await AvailabilityAPI.get(accountId);
      commit(types.SET_AVAILABILITY_REASONS, response.data);
      commit(types.SET_AVAILABILITY_UI_FLAG, { fetchingList: false });

      return response.data;
    } catch (error) {
      commit(types.SET_AVAILABILITY_UI_FLAG, { fetchingList: false });

      return throwErrorMessage(error);
    }
  },

  createAvailability: async function createAvailability(
    { commit },
    { payload }
  ) {
    commit(types.SET_AVAILABILITY_UI_FLAG, { creatingItem: true });
    try {
      const response = await AvailabilityAPI.create(payload);
      commit(types.ADD_AVAILABILITY_REASON, response.data);
      commit(types.SET_AVAILABILITY_UI_FLAG, { creatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.SET_AVAILABILITY_UI_FLAG, { creatingItem: false });
      return throwErrorMessage(error);
    }
  },

  updateAvailability: async function updateAvailability(
    { commit },
    { id, payload }
  ) {
    commit(types.SET_AVAILABILITY_UI_FLAG, { updatingItem: true });
    try {
      const response = await AvailabilityAPI.update(id, payload);
      commit(types.EDIT_AVAILABILITY_REASON, response.data);
      commit(types.SET_AVAILABILITY_UI_FLAG, { updatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.SET_AVAILABILITY_UI_FLAG, { updatingItem: false });
      return throwErrorMessage(error);
    }
  },

  deleteAvailability: async function deleteAvailability({ commit }, { id }) {
    commit(types.SET_AVAILABILITY_UI_FLAG, { deletingItem: true });
    try {
      await AvailabilityAPI.delete(id);
      commit(types.DELETE_AVAILABILITY_REASON, id);
      commit(types.SET_AVAILABILITY_UI_FLAG, { deletingItem: false });
      return id;
    } catch (error) {
      commit(types.SET_AVAILABILITY_UI_FLAG, { deletingItem: false });
      return throwErrorMessage(error);
    }
  },
};

const mutations = {
  [types.SET_AVAILABILITY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_AVAILABILITY_REASONS]: MutationHelpers.set,

  [types.ADD_AVAILABILITY_REASON]: MutationHelpers.create,

  [types.EDIT_AVAILABILITY_REASON]: MutationHelpers.update,

  [types.DELETE_AVAILABILITY_REASON]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
